import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import {
    ClientSubscriptionType,
    ClientSubscriptionService,
    ClientSubscriptionPage,
    ClientSubscriptionForm,
} from '../../../services/client-subscription.service';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { ToastService } from '../../../../shared/services/toast.service';

@Component({
    selector: 'app-client-subscription-page',
    templateUrl: './client-subscription-page.component.html',
    styleUrls: ['./client-subscription-page.component.scss'],
})
export class ClientSubscriptionPageComponent implements OnInit {
    @Input() public type: ClientSubscriptionType;
    @Output() public edit = new EventEmitter();

    private data: ClientSubscriptionPage[];
    public gridView: GridDataResult;
    public updateData: ClientSubscriptionForm[];

    constructor(
        private clientSubscriptionService: ClientSubscriptionService,
        private toast: ToastService
    ) {}

    ngOnInit() {
        this.getData();
    }

    getData() {
        this.clientSubscriptionService
            .getSubscriptionPage(this.type.clientSubscriptionTypeKey)
            .subscribe((d) => {
                this.data = d;
                this.formatData();
            });
    }

    update() {
        this.clientSubscriptionService.updateSubscription(this.updateData).subscribe((data) => {
            this.toast.success(`${this.type.name} subscription has been updated.`);
            this.updateData = [];
        });
    }

    formatData() {
        let modules: Module[] = this.data
            .filter((page: ClientSubscriptionPage) => page.applicationPageTypeKey == 1)
            .map((mod: ClientSubscriptionPage) => ({
                page: mod,
                pages: this.data
                    .filter(
                        (subMod: ClientSubscriptionPage) =>
                            subMod.applicationPageTypeKey == 2 &&
                            subMod.parentApplicationPageKey == mod.applicationPageKey
                    )
                    .map((subMod: ClientSubscriptionPage) => ({
                        page: subMod,
                        pages: this.data.filter(
                            (page: ClientSubscriptionPage) =>
                                page.applicationPageTypeKey == 3 &&
                                page.parentApplicationPageKey == subMod.applicationPageKey
                        ),
                    })),
            }));

        this.updateGrid(modules);
    }

    updateGrid(data) {
        this.gridView = {
            data: data,
            total: data.length,
        };
    }

    editSubscription() {
        this.edit.emit();
    }

    clickUpdateModule(page: ClientSubscriptionPage) {
        if (!this.updateData) {
            this.updateData = [];
        }

        let value = page.hasPage;
        let item = this.updateData.find((m) => m.applicationPageKey == page.applicationPageKey);
        if (item) {
            let itemIndex = this.updateData.indexOf(item);
            if (itemIndex >= 0) {
                this.updateData.splice(itemIndex, 1);
            }
        } else {
            this.updateData.push({
                applicationPageKey: page.applicationPageKey,
                clientSubscriptionTypeKey: this.type.clientSubscriptionTypeKey,
                isActive: value,
            });
        }
    }
}

export interface Module {
    page: ClientSubscriptionPage;
    pages: ClientSubscriptionPage[] | Module[];
}
